const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.files/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.files/LIST_FILES_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        ...action.response.pagination,
      };
    case 'table.files/LIST_FILES_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };
    case 'table.files/READ_FILE_SUCCESS':
      return {
        ...state,
        flyout: action.response.data,
      };
    default:
      return state;
  }
}
